module.exports = {
      id: "loading-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite.svg#loading",
      toString: function () {
        return this.url;
      }
    }